<template>
  <loader />
</template>
<script>
import PreferencesService from '../../services/PreferencesService';
import OnboardingService from '../../services/OnboardingService';
import UserService from '../../services/UserService';
export default {
  data() {
    return {
      SOURCE_ID: ''
    };
  },
  mounted() {
    const query = this.$route.query;
    this.checkForConsent(query.admin_consent || query.code, query.state);
  },
  methods: {
    archiveToolBoxSubscription(id, orgId, type, consent = true) {
      return PreferencesService.addPreference(
        this.$preference.ARCHIVE_TOOL_BOX_SUBSCRIPTIONS,

        {
          subscriptionDetails: {
            HAS_CONSENT: consent,
            SOURCE_ID: type,
            SYNC_PERIOD: '1H',
            INGEST_ALL_VERSIONS: false,
            ONBOARD_COMPLETE: this.$enums.exportableConnectors.includes(
              this.SOURCE_ID
            )
              ? consent
              : false
          }
        },
        null,
        id,
        orgId
      );
    },

    async checkForConsent(hasConsent, state) {
      if (
        (hasConsent &&
          typeof hasConsent !== 'boolean' &&
          //eslint-disable-next-line
          hasConsent.toLowerCase() == 'true') ||
        hasConsent
      ) {
        const data = state.split('___');
        const orgId = data[0];

        // eslint-disable-next-line

        if (state.includes('id=')) {
          // this is based on api response; hence not removing 3 and 5
          // eslint-disable-next-line
          const id = data[1].substr(3);
          // eslint-disable-next-line
          const type = data[2].substr(5);
          // Check for export project job
          if (this.$enums.exportableConnectors.includes(type)) {
            try {
              this.SOURCE_ID = type;
              await this.createDropboxAccessToken(type, orgId, hasConsent);
              await this.archiveToolBoxSubscription(id, orgId, type);
              this.$router.push({
                path: 'success',
                query: { type }
              });
            } catch (err) {
              await this.archiveToolBoxSubscription(id, orgId, type, false);
              this.snackbar('error', err);
              this.$router.push('failure');
            }
            return;
          }
          // eslint-disable-next-line
          const isOnboarding = data?.[3];
          if (type) {
            if (type === this.$preference.SINGLE_SIGN_ON_STATUS) {
              try {
                await PreferencesService.addPreference(
                  this.$preference.SINGLE_SIGN_ON_STATUS,
                  {
                    status: { HAS_CONSENT: true }
                  },
                  null,
                  id,
                  orgId
                );
                await UserService.updateOrgSSOGroup('true', orgId);
                this.$router.push({
                  path: 'success',
                  query: { type: 'sso' }
                });
              } catch (err) {
                this.snackbar('error', err);
                this.$router.push('failure');
              }
            } else {
              try {
                await this.createDropboxAccessToken(type, orgId, hasConsent);

                await this.archiveToolBoxSubscription(id, orgId, type);
                if (isOnboarding) {
                  try {
                    await OnboardingService.onboardingOrg(orgId, type);
                    this.$router.push({
                      path: 'success',
                      query: { type: type }
                    });
                  } catch (err) {
                    this.snackbar('error', err);
                    this.$router.push('failure');
                  }

                  return;
                }

                await OnboardingService.subscribeService(type, orgId);
                this.$router.push({
                  path: 'success',
                  query: { type: type }
                });
              } catch (err) {
                await this.archiveToolBoxSubscription(id, orgId, type, false);
                this.snackbar('error', err);
                this.$router.push('failure');
              }
            }
          }
        } else {
          const type = data[1];
          // Check for export project job
          if (this.$enums.exportableConnectors.includes(type)) {
            try {
              this.SOURCE_ID = type;
              await this.createDropboxAccessToken(type, orgId, hasConsent);
              await this.archiveToolBoxSubscription(null, orgId, type);
              this.$router.push({
                path: 'success',
                query: { type }
              });
            } catch (err) {
              await this.archiveToolBoxSubscription(null, orgId, type, false);
              this.snackbar('error', err);
              this.$router.push('failure');
            }
            return;
          }
          // eslint-disable-next-line
          const isOnboarding = data?.[2];
          if (type === this.$preference.SINGLE_SIGN_ON_STATUS) {
            try {
              await PreferencesService.addPreference(
                this.$preference.SINGLE_SIGN_ON_STATUS,
                {
                  status: { HAS_CONSENT: true }
                },
                null,
                null,
                orgId
              );
              await UserService.updateOrgSSOGroup('true', orgId);
              this.$router.push({
                path: 'success',
                query: { type: 'sso' }
              });
            } catch (err) {
              this.snackbar('error', err);
              this.$router.push('failure');
            }
          } else {
            try {
              await this.createDropboxAccessToken(type, orgId, hasConsent);

              const response = await this.archiveToolBoxSubscription(
                null,
                orgId,
                type
              );
              if (isOnboarding) {
                try {
                  await OnboardingService.onboardingOrg(orgId, type);

                  this.$router.push({
                    path: 'success',
                    query: { type: type }
                  });
                } catch (err) {
                  this.snackbar('error', err);
                  this.$router.push('failure');
                }

                return;
              }
              await OnboardingService.subscribeService(type, orgId)
                .then(() =>
                  this.$router.push({
                    path: 'success',
                    query: { type: type }
                  })
                )
                .catch(async err => {
                  this.snackbar('error', err);
                  await this.archiveToolBoxSubscription(
                    response.data.body[0].id,
                    orgId,
                    type,
                    false
                  );
                  this.$router.push('failure');
                });
            } catch (err) {
              // await this.archiveToolBoxSubscription(
              //   response.data.body[0].id,
              //   orgId,
              //   type,
              //   false
              // );
              this.snackbar('error', err);
              this.$router.push('failure');
            }
          }
        }
      } else {
        this.$router.push('failure');
      }
    },
    /**
     * To create access token of Dropbox
     *
     * @param {String} connectorId , sourceId/connectorId of connector
     * @param {String} orgId , currently selected org Id
     * @param {String} hasConsent , consent code of dropbox
     */
    async createDropboxAccessToken(connectorId, orgId, hasConsent) {
      const dropboxConnectors = [
        this.$enums.O365_CONNECTORS.dropbox.connectorId,
        this.$enums.O365_CONNECTORS.export_to_dropbox.connectorId
      ];
      // If connectorId present in dropboxConnectors, then first create dropbox accessToken
      // If success comes in response then only go for further steps of calling preference service & creating Job
      if (dropboxConnectors.includes(connectorId)) {
        await this.$services.onboarding.createDropboxAccessToken(
          orgId,
          hasConsent,
          connectorId
        );
      }
    }
  }
};
</script>
